import { BudgetSummary } from './budgetCalculatorModel'
import { BudgetStatistics } from './budgetModel'

export type BudgetDonutSlice = {
  label: string
  value: number
  color: string
}

export const buildBudgetDonutSlices = (summary: BudgetSummary, statistics: BudgetStatistics): BudgetDonutSlice[] => [
  { label: 'Labor', value: summary.labor, color: '#ff6b4a' },
  { label: 'Materials', value: summary.materials, color: '#ffc0cb' },
  { label: 'Equipment', value: summary.equipmentStatistics.totalAnnualCost, color: '#4169e1' },
  { label: 'Subcontractors', value: summary.subcontractors, color: '#90ee90' },
  { label: 'Overhead', value: statistics.totalOverhead - summary.equipmentStatistics.overheadAnnualCost, color: '#2f4f4f' },
  { label: 'Net Profit', value: Math.max(statistics.netProfit, 0), color: '#8b0000' }
]
